import usePrice from '@commerce/product/use-price'
import { BundleInfo } from '@lib/helpers/general'
import cn from 'clsx'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
interface Props {
  bundleOptionItem: BundleInfo | undefined
  price: number
  currencyCode: string
  selected: boolean
}
const BundleProductOptionItem: FC<Props> = ({
  bundleOptionItem,
  price,
  currencyCode,
  selected,
}) => {
  const { t } = useTranslation('common')
  const { price: formattedPrice } = usePrice({
    amount: price,
    currencyCode,
    suffix: `(${t('excl-vat')})`,
  })
  if (!bundleOptionItem) return null
  return (
    <div
      className={cn(
        'flex cursor-pointer justify-between rounded-sm border  bg-ui-white px-4 py-3',
        { 'border-ui-grey-25': !selected, 'border-ui-dark-grey': selected }
      )}
    >
      <div className="flex flex-col gap-1">
        <div className="body-2-bold">{bundleOptionItem.name}</div>
        <div className="body-2">{bundleOptionItem.description}</div>
      </div>
      <div className="body-2 flex items-center">{formattedPrice}</div>
    </div>
  )
}

export default BundleProductOptionItem
